import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

export const VENDOR_CORE_FIELDS = `
  id
  name
  street
  city
  state
  postalCode { formatted, value}
  phoneNumber { formatted, value}
  email
  notes
  taxClassification
  llc
  taxIdType
  taxIdNumber
`;

const VENDOR_FIELDS = `
  ${VENDOR_CORE_FIELDS }
  files {
    id
    name
    fileUrl
  }
`;

const VENDOR_VARIABLES = `
  $name: String!
  $street: String
  $city: String
  $state: String
  $postalCode: String
  $phoneNumber: String
  $email: String
  $notes: String
  $taxClassification: String
  $llc: Boolean
  $taxIdType: String
  $taxIdNumber: String
`;

const VENDOR_ARGUMENTS = `
  name: $name
  street: $street
  city: $city
  state: $state
  postalCode: $postalCode
  phoneNumber: $phoneNumber
  email: $email
  notes: $notes
  taxClassification: $taxClassification
  llc: $llc
  taxIdType: $taxIdType
  taxIdNumber: $taxIdNumber
`;

const VENDOR_FIELDS_AND_ERRORS = `
  vendor {
    ${VENDOR_FIELDS}
  }
  ${ERRORS}
`;

export const VENDORS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    vendorsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${VENDOR_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_VENDOR = gql`
  mutation CreateVendor(
    ${VENDOR_VARIABLES}
  ) {
    createVendor(
      ${VENDOR_ARGUMENTS}
    ) {
      ${VENDOR_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_VENDOR = gql`
  mutation UpdateVendor(
    $id: ID!
    ${VENDOR_VARIABLES}
  ) {
    updateVendor(
      id: $id
      ${VENDOR_ARGUMENTS}
    ) {
      ${VENDOR_FIELDS_AND_ERRORS}
    }
  }
`;

export const VENDORS_SELECT = gql`
  query Vendors {
    vendors {
      ${VENDOR_CORE_FIELDS}
    }
  }
`;

export const VENDOR = gql`
  query Vendor($id: ID!) {
    vendor(id: $id) {
      ${VENDOR_FIELDS}
    }
  }
`;

export const HIDE_VENDOR = gql`
  mutation HideVendor($id: ID!) {
    hideVendor(id: $id) {
      vendor {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_VENDOR = gql`
  mutation UnhideVendor($id: ID!) {
    unhideVendor(id: $id) {
      vendor {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

